// extracted by mini-css-extract-plugin
export var blue = "_4a-g";
export var brand = "_4a-c";
export var darkGrey = "_4a-f";
export var disabled = "_4a-5";
export var disabledSubtle = "_4a-6";
export var error = "_4a-7";
export var green = "_4a-h";
export var grey = "_4a-e";
export var icon = "_4a-0";
export var inherit = "_4a-b";
export var lightGrey = "_4a-d";
export var orange = "_4a-j";
export var pink = "_4a-l";
export var primary = "_4a-1";
export var purple = "_4a-m";
export var quaternary = "_4a-4";
export var red = "_4a-k";
export var secondary = "_4a-2";
export var success = "_4a-a";
export var tertiary = "_4a-3";
export var warning = "_4a-8";
export var warningSecondary = "_4a-9";
export var white = "_4a-n";
export var yellow = "_4a-i";